import { createContext, useContext, ReactNode } from 'react';
import { useMobileMenu } from '../hooks/use-mobile-menu';

interface MobileMenuContextType {
    isMobileMenuOpen: boolean;
    isMobile: boolean;
    toggleMobileMenu: () => void;
    closeMobileMenu: () => void;
}

const MobileMenuContext = createContext<MobileMenuContextType | undefined>(undefined);

interface MobileMenuProviderProps {
    children: ReactNode;
}

export const MobileMenuProvider = ({ children }: MobileMenuProviderProps) => {
    const mobileMenuState = useMobileMenu();

    return (
        <MobileMenuContext.Provider value={mobileMenuState}>
            {children}
        </MobileMenuContext.Provider>
    );
};

export const useMobileMenuContext = () => {
    const context = useContext(MobileMenuContext);
    if (context === undefined) {
        throw new Error('useMobileMenuContext must be used within a MobileMenuProvider');
    }
    return context;
}; 